import cn from 'classnames'
import React, { useMemo } from 'react'

import { useTranslation } from '@lib/i18n'
import utils from '@lib/utils'

export interface PaxBreakdownProps {
  passengerCodes: Passenger.Code[]
  className?: string
}
const PaxBreakdown = ({ className, passengerCodes }: PaxBreakdownProps) => {
  const { t } = useTranslation()

  const passengersCount = passengerCodes.length

  const typesFrequency = useMemo(() => {
    return utils.array.frequencyBy(passengerCodes, code => code)
  }, [passengerCodes])

  const paxBreakdownText = typesFrequency
    .map(([key, value]) => `${value} ${t(`passengers.types.${key}`, { count: value })}`)
    .join(', ')

  return (
    <div className={cn('pax-breakdown', className)} data-tag={'pax-breakdown'}>
      <span>
        <b>{`${t('confirmation.passengers.passenger', { count: passengersCount })}: `}</b>
      </span>
      <span>{paxBreakdownText}</span>
    </div>
  )
}

export default PaxBreakdown
